

const iconStyle = { position: 'absolute', right: 0, top: "50%", transform: "translateY(-50%)" };
const Up = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={iconStyle} width="13.671" height="8.382" viewBox="0 0 13.671 8.382">
            <g data-name="Component 136 – 1">
                <path d="m2 5 6.131 7.177L14.261 5" transform="rotate(180 7.483 6.339)" fill="none" stroke="#14a4c2" strokeLinecap="round" strokeLinejoin="round" filrule="evenodd"  data-name="Drop Down" />
            </g>
        </svg>       
    )
};

export default Up